import React, { useState } from 'react';

const ImageFallback = ({ src, className, onClick, onMouseOver, onMouseLeave }) => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleError = () => {
    // Append a parameter to the URL to force reload
    setImgSrc(`${src}?v=${new Date().getTime()}`);
  };

  return (
    <img
      className={className}
      src={imgSrc}
      alt=""
      onClick={(e) => onClick(e)}
      onMouseOver={(e) => onMouseOver(e)}
      onMouseLeave={(e) => onMouseLeave(e)}
      onError={handleError}
    />
  );
};

export default ImageFallback;
